import type { InjectionKey } from 'vue'
import type { FieldColorInjection } from '~/composables/useInjectedColor'
import type { FormIdInjection } from '~/composables/useInjectedId'

export const $FormId: InjectionKey<FormIdInjection> = Symbol('field.inject.id')
export const $FieldColor: InjectionKey<FieldColorInjection> = Symbol('field.inject.color')
export const $I18nBaseKey: InjectionKey<Ref<string> | ComputedRef<string>> =
  Symbol('i18n.inject.base-key')
